/* eslint-disable func-names */
// Read-only condensed view of TKT1 Etsy Info Pack focused on the device pack / AnyDesk access.
// AnyDesk fields live on the PC (TKT1_PCInfo) and arrive merged into device_pack_info by the info pack API.
import React, { Component } from "react";
import { connect } from "react-redux";
import { getTKT1EtsyInfoPacks } from '../actions';
import Pagination from "../components/Pagination";
import queryString from 'query-string';
import {
  Badge,
  Button,
  Form,
  Table,
  Container,
  Row,
  Col,
  InputGroup,
  Modal
} from "react-bootstrap";
import { FaTimes, FaEye, FaEyeSlash, FaCopy, FaExternalLinkAlt } from 'react-icons/fa';
import IframeModal from '../components/IframeModal/IframeModal';

const STORAGE_QUERY_KEY = 'tkt1_etsy_info_device_pack_query';
const STORAGE_VIEW_CONFIG_KEY = 'TKT1EtsyInfoDevicePack_ViewConfig';
const STORAGE_COLUMN_WIDTHS_KEY = 'TKT1EtsyInfoDevicePack_ColumnWidths';
const PAGE_PATH = '/admin/tkt1-etsy/etsy-info-device-pack';

class TKT1EtsyInfoDevicePack extends Component {
  initQuery = {
    currentPage: 1,
    itemsPerPage: 100,
    sortBy: 'device_pack_location_id',
    sortOrder: 1,
    search: '',
    status: ''
  }

  initShowColumns = {
    device_pack_location_id: true,
    device_status: true,
    etsy_shop_name: true,
    etsy_shop_status: true,
    anydesk_id: true,
    anydesk_password: true,
    MID: true,
    status: true
  }

  initColumnWidths = {
    stt: 60,
    device_pack_location_id: 180,
    device_status: 130,
    etsy_shop_name: 220,
    etsy_shop_status: 140,
    anydesk_id: 160,
    anydesk_password: 180,
    MID: 140,
    status: 120,
    actions: 80
  }

  columnLabels = {
    device_pack_location_id: 'Device Pack ID',
    device_status: 'Device Status',
    etsy_shop_name: 'Etsy Shop Name',
    etsy_shop_status: 'Etsy Shop Status',
    anydesk_id: 'AnyDesk ID',
    anydesk_password: 'AnyDesk Password',
    MID: 'Etsy Info MID',
    status: 'Trạng thái'
  }

  constructor() {
    super();
    this.state = {
      query: this.initQuery,
      showColumns: this.initShowColumns,
      columnWidths: this.initColumnWidths,
      showConfigModal: false,
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: '',
      // _id of rows whose AnyDesk password is currently revealed in the table
      revealedPasswords: {},
      isResizing: false,
      resizingColumn: null,
      resizeStartX: null,
      resizeStartWidth: null
    };
  }

  componentDidMount() {
    document.title = 'TKT1 Etsy Info Device Pack';
    const queryStringFromUrl = window.location.search;

    // Check if URL has any query parameters
    const hasUrlParams = queryStringFromUrl && queryStringFromUrl.length > 1;

    const viewConfig = JSON.parse(localStorage.getItem(STORAGE_VIEW_CONFIG_KEY));
    const columnWidths = JSON.parse(localStorage.getItem(STORAGE_COLUMN_WIDTHS_KEY));

    let restoredQuery = { ...this.initQuery };

    if (hasUrlParams) {
      // URL has query parameters - override localStorage
      const queryObject = queryString.parse(queryStringFromUrl);

      // Parse numeric values
      ['itemsPerPage', 'currentPage', 'sortOrder'].forEach(key => {
        if (queryObject[key]) {
          queryObject[key] = parseInt(queryObject[key]);
        }
      });

      restoredQuery = { ...this.initQuery, ...queryObject };
    } else {
      // No URL params - use localStorage
      const savedQuery = JSON.parse(localStorage.getItem(STORAGE_QUERY_KEY));
      if (savedQuery) {
        restoredQuery = { ...this.initQuery, ...savedQuery };
        restoredQuery.itemsPerPage = parseInt(restoredQuery.itemsPerPage || this.initQuery.itemsPerPage);
        restoredQuery.currentPage = parseInt(restoredQuery.currentPage || this.initQuery.currentPage);
        restoredQuery.sortOrder = parseInt(restoredQuery.sortOrder || this.initQuery.sortOrder);
      }
    }

    this.setState({
      query: restoredQuery,
      showColumns: {
        ...this.initShowColumns,
        ...(viewConfig || {})
      },
      columnWidths: {
        ...this.initColumnWidths,
        ...(columnWidths || {})
      }
    }, () => {
      this.loadData();
    });

    // Add mouse event listeners for column resizing
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);
  }

  componentWillUnmount() {
    // Remove mouse event listeners
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
  }

  loadData = () => {
    this.props.getTKT1EtsyInfoPacks(this.prepareApiQuery(this.state.query));
  }

  // Apply a new query: persist, sync URL and reload
  applyQuery = (newQuery) => {
    const trimmedQuery = {
      ...newQuery,
      search: (newQuery.search || '').trim()
    };
    localStorage.setItem(STORAGE_QUERY_KEY, JSON.stringify(trimmedQuery));
    this.setState({ query: trimmedQuery }, () => {
      this.updateUrl(trimmedQuery);
      this.props.getTKT1EtsyInfoPacks(this.prepareApiQuery(trimmedQuery));
    });
  }

  handleChangeSearch = (e) => {
    this.setState({
      query: { ...this.state.query, search: e.target.value }
    })
  }

  handleClearSearch = () => {
    this.applyQuery({ ...this.state.query, search: '', currentPage: 1 });
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  }

  handleStatusChange = (e) => {
    this.applyQuery({ ...this.state.query, status: e.target.value, currentPage: 1 });
  }

  handleSelectSort = (e) => {
    this.applyQuery({ ...this.state.query, sortBy: e.target.value });
  }

  handleSelectSortOrder = (e) => {
    this.applyQuery({ ...this.state.query, sortOrder: parseInt(e.target.value) });
  }

  handleColumnToggle = (columnKey) => {
    this.setState(prevState => {
      const newShowColumns = {
        ...prevState.showColumns,
        [columnKey]: !prevState.showColumns[columnKey]
      };

      // Save view config to localStorage
      localStorage.setItem(STORAGE_VIEW_CONFIG_KEY, JSON.stringify(newShowColumns));

      return { showColumns: newShowColumns };
    })
  }

  // Column resizing handlers
  resetColumnWidths = () => {
    this.setState({ columnWidths: this.initColumnWidths });
    localStorage.removeItem(STORAGE_COLUMN_WIDTHS_KEY);
  }

  handleMouseDown = (e, columnKey) => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({
      isResizing: true,
      resizingColumn: columnKey,
      resizeStartX: e.clientX,
      resizeStartWidth: this.state.columnWidths[columnKey]
    });

    document.body.classList.add('table-resizing');
  }

  handleMouseMove = (e) => {
    if (!this.state.isResizing || !this.state.resizingColumn) return;

    e.preventDefault();
    const deltaX = e.clientX - this.state.resizeStartX;
    const newWidth = Math.max(50, this.state.resizeStartWidth + deltaX);
    const resizingColumn = this.state.resizingColumn;

    this.setState(prevState => ({
      columnWidths: {
        ...prevState.columnWidths,
        [resizingColumn]: newWidth
      }
    }));
  }

  handleMouseUp = () => {
    if (this.state.isResizing) {
      this.setState({
        isResizing: false,
        resizingColumn: null,
        resizeStartX: null,
        resizeStartWidth: null
      });

      document.body.classList.remove('table-resizing');

      // Save column widths to localStorage
      localStorage.setItem(STORAGE_COLUMN_WIDTHS_KEY, JSON.stringify(this.state.columnWidths));
    }
  }

  // Map status to Vietnamese
  mapStatus = (status) => {
    if (!status) return '-';
    switch (status.toLowerCase()) {
      case 'active':
        return 'Hoạt động';
      case 'inactive':
        return 'Không hoạt động';
      case 'suspended':
        return 'Tạm dừng';
      case 'deleted':
        return 'Đã xóa';
      default:
        return status;
    }
  }

  statusBadgeVariant = (status) => {
    switch ((status || '').toLowerCase()) {
      case 'active': return 'success';
      case 'inactive': return 'warning';
      case 'suspended': return 'info';
      case 'deleted': return 'danger';
      default: return 'secondary';
    }
  }

  formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? String(dateString) : date.toLocaleDateString('vi-VN');
  }

  // Registration status of the shop, mirrors the dot on the Etsy Info Pack page:
  // green = buyer + seller registered, blue = buyer only, red = neither
  getRegistrationStatus = (pack) => {
    if (pack.seller_registration_date) {
      return {
        color: '#28a745',
        title: `${pack.buyer_registration_date ? `Đăng ký buyer: ${this.formatDate(pack.buyer_registration_date)}` : 'Chưa đăng ký buyer'} | Đăng ký seller: ${this.formatDate(pack.seller_registration_date)}`
      };
    }
    if (pack.buyer_registration_date) {
      return {
        color: '#007bff',
        title: `Đăng ký buyer: ${this.formatDate(pack.buyer_registration_date)} | Chưa đăng ký seller`
      };
    }
    return { color: '#dc3545', title: 'Chưa đăng ký buyer | Chưa đăng ký seller' };
  }

  // Device pack status (AVAILABLE / IN USE / NOT WORKING / CANCEL), same as the Device Pack page
  mapDeviceStatus = (status) => {
    if (!status) return '-';
    switch (status.toUpperCase()) {
      case 'AVAILABLE': return 'Có sẵn';
      case 'IN USE': return 'Đang sử dụng';
      case 'NOT WORKING': return 'Không hoạt động';
      case 'CANCEL': return 'Hủy';
      default: return status;
    }
  }

  deviceStatusBadgeVariant = (status) => {
    switch ((status || '').toUpperCase()) {
      case 'AVAILABLE': return 'success';
      case 'IN USE': return 'warning';
      case 'NOT WORKING': return 'danger';
      case 'CANCEL': return 'danger';
      default: return 'secondary';
    }
  }

  // Badge colour of a Device Pack ID by its prefix (CT / TT / VC), others fall back to warning
  devicePackBadgeVariant = (devicePackId) => {
    const prefix = String(devicePackId || '').toUpperCase().slice(0, 2);
    switch (prefix) {
      case 'CT': return 'primary';
      case 'TT': return 'success';
      case 'VC': return 'danger';
      default: return 'warning';
    }
  }

  // Copy text to clipboard
  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      console.log('Copied to clipboard:', text);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  togglePasswordReveal = (id) => {
    this.setState(prevState => ({
      revealedPasswords: {
        ...prevState.revealedPasswords,
        [id]: !prevState.revealedPasswords[id]
      }
    }));
  }

  handleEtsyInfoPackClick = (mid) => {
    if (mid) {
      this.setState({
        showIframeModal: true,
        iframeUrl: `/admin/tkt1-etsy/etsy-info-pack-detail/${mid}`,
        iframeTitle: `Info Pack Detail - ${mid}`
      });
    }
  }

  // Open the Registered Shop page filtered to this info pack
  handleRegisteredShopClick = (pack) => {
    if (pack && pack.MID) {
      this.setState({
        showIframeModal: true,
        iframeUrl: `/admin/tkt1-etsy/registered-shop?ref_etsy_info_pack_mid=${encodeURIComponent(pack.MID)}`,
        iframeTitle: `Registered Shop - ${pack.MID}`
      });
    }
  }

  handleCloseIframeModal = () => {
    this.setState({
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: ''
    });
  }

  // AnyDesk lives on the PC record, so edits happen on the PC Info page
  handlePcInfoClick = (pack) => {
    const pcSN = pack.device_pack_info?.PCSN;
    if (pcSN) {
      this.setState({
        showIframeModal: true,
        iframeUrl: `/admin/tkt1-device/pc-info?search=${encodeURIComponent(pcSN)}&search_exact=true`,
        iframeTitle: `PC Info - ${pcSN}`
      });
    }
  }

  // Helper function to prepare API query
  prepareApiQuery = (query) => {
    const { showColumns, ...baseQuery } = query;
    const apiQuery = {
      ...baseQuery,
      search: query.search ? query.search.trim() : ''
    };

    if (query.status && query.status.trim()) {
      apiQuery.status = query.status;
    }

    return apiQuery;
  }

  handleChangeItemsPerPage = (e) => {
    const itemsPerPage = parseInt(e.target.value);
    this.applyQuery({ ...this.state.query, itemsPerPage, currentPage: 1 });
  }

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.handleSearch();
  }

  handleSearch = () => {
    this.applyQuery({ ...this.state.query, currentPage: 1 });
  }

  updateUrl = (query) => {
    const { history } = this.props;
    // Remove showColumns from URL query - it's only for client display
    const { showColumns, ...urlQuery } = query;
    const queryStr = queryString.stringify(urlQuery);

    history.push({
      pathname: PAGE_PATH,
      search: queryStr,
    });
  }

  updatePage = (itemOffset, newPage) => {
    if (newPage == this.state.query.currentPage)
      return;

    this.applyQuery({ ...this.state.query, currentPage: newPage });
  }

  renderSearchFilter = () => {
    return <>
      <Row className="mb-3">
        <Col md="4">
          <InputGroup className="mb-3">
            <InputGroup.Text>Tìm kiếm</InputGroup.Text>
            <Form.Control
              value={this.state.query.search}
              onChange={this.handleChangeSearch}
              onKeyPress={this.handleKeyPress}
              placeholder="MID, Device Pack ID, AnyDesk ID..."
              aria-label="search"
              aria-describedby="basic-addon1"
            />
            {this.state.query.search && (
              <InputGroup.Text
                onClick={this.handleClearSearch}
                style={{
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  borderLeft: 'none'
                }}
                title="Xóa tìm kiếm"
              >
                <FaTimes size={12} />
              </InputGroup.Text>
            )}
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Trạng thái</InputGroup.Text>
            <Form.Select
              value={this.state.query.status}
              onChange={this.handleStatusChange}
            >
              <option value="">Tất cả</option>
              <option value="active">Hoạt động</option>
              <option value="inactive">Không hoạt động</option>
              <option value="suspended">Tạm dừng</option>
              <option value="deleted">Đã xóa</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Sắp xếp theo</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortBy}
              onChange={this.handleSelectSort}
            >
              <option value="device_pack_location_id">Device Pack ID</option>
              <option value="MID">Etsy Info MID</option>
              <option value="created_at">Ngày tạo</option>
              <option value="updated_at">Ngày cập nhật</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Thứ tự</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortOrder}
              onChange={this.handleSelectSortOrder}
            >
              <option value="-1">Giảm dần</option>
              <option value="1">Tăng dần</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2" className="d-flex align-items-center justify-content-end">
          <Button
            className="btn-fill btn"
            type="submit"
            variant="primary"
            onClick={this.handleSubmit}
          >
            Tìm kiếm
          </Button>
        </Col>
      </Row>
    </>
  }

  renderHeaderCell = (columnKey, label) => {
    const { columnWidths } = this.state;
    return (
      <th style={{ width: `${columnWidths[columnKey]}px`, position: 'relative' }}>
        {label}
        <div
          className="resize-handle"
          onMouseDown={(e) => this.handleMouseDown(e, columnKey)}
        />
      </th>
    );
  }

  renderCopyable = (value, title, badgeVariant) => {
    if (!value) return '-';
    return (
      <div className="d-flex align-items-center gap-2">
        {badgeVariant ? (
          <Badge bg={badgeVariant} style={{ fontSize: '0.9em', padding: '6px 10px' }}>{value}</Badge>
        ) : (
          <span>{value}</span>
        )}
        <FaCopy
          size={12}
          style={{ cursor: 'pointer', color: '#6c757d' }}
          onClick={() => this.copyToClipboard(value)}
          title={`Copy ${title}`}
        />
      </div>
    );
  }

  renderPasswordCell = (pack) => {
    const password = pack.device_pack_info?.anydesk_password;
    if (!password) return '-';
    const revealed = !!this.state.revealedPasswords[pack._id];
    return (
      <div className="d-flex align-items-center gap-2">
        <span style={{ fontFamily: 'monospace' }}>
          {revealed ? password : '••••••••'}
        </span>
        {revealed ? (
          <FaEyeSlash
            size={12}
            style={{ cursor: 'pointer', color: '#6c757d' }}
            onClick={() => this.togglePasswordReveal(pack._id)}
            title="Ẩn mật khẩu"
          />
        ) : (
          <FaEye
            size={12}
            style={{ cursor: 'pointer', color: '#6c757d' }}
            onClick={() => this.togglePasswordReveal(pack._id)}
            title="Hiện mật khẩu"
          />
        )}
        <FaCopy
          size={12}
          style={{ cursor: 'pointer', color: '#6c757d' }}
          onClick={() => this.copyToClipboard(password)}
          title="Copy AnyDesk Password"
        />
      </div>
    );
  }

  renderPackTable = () => {
    const { etsyInfoPacks } = this.props;
    const { showColumns, columnWidths } = this.state;

    // Ensure packs is an array and filter out any null/undefined items
    const safePacks = Array.isArray(etsyInfoPacks) ? etsyInfoPacks.filter(pack => pack != null && typeof pack === 'object') : [];

    return (
      <Table striped bordered hover style={{ tableLayout: 'auto' }}>
        <thead>
          <tr>
            {this.renderHeaderCell('stt', 'STT')}
            {showColumns.device_pack_location_id && this.renderHeaderCell('device_pack_location_id', 'Device Pack ID')}
            {showColumns.device_status && this.renderHeaderCell('device_status', 'Device Status')}
            {showColumns.etsy_shop_name && this.renderHeaderCell('etsy_shop_name', 'Etsy Shop Name')}
            {showColumns.etsy_shop_status && this.renderHeaderCell('etsy_shop_status', 'Etsy Shop Status')}
            {showColumns.anydesk_id && this.renderHeaderCell('anydesk_id', 'AnyDesk ID')}
            {showColumns.anydesk_password && this.renderHeaderCell('anydesk_password', 'AnyDesk Password')}
            {showColumns.MID && this.renderHeaderCell('MID', 'Etsy Info MID')}
            {showColumns.status && this.renderHeaderCell('status', 'Trạng thái')}
            <th style={{ width: `${columnWidths.actions}px` }}>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {safePacks.length === 0 && (
            <tr>
              <td colSpan={Object.values(showColumns).filter(Boolean).length + 2} className="text-center text-muted">
                Không có dữ liệu
              </td>
            </tr>
          )}
          {safePacks.map((pack, index) => {
            const shopName = pack.trusted_story_info?.etsy_shop_name;
            const registration = this.getRegistrationStatus(pack);
            const registeredShop = pack.registered_etsy_shop_info;
            return (
              <tr key={pack._id || index}>
                <td>{(this.state.query.currentPage - 1) * this.state.query.itemsPerPage + index + 1}</td>
                {showColumns.device_pack_location_id && (
                  <td>{this.renderCopyable(pack.device_pack_location_id, 'Device Pack ID', this.devicePackBadgeVariant(pack.device_pack_location_id))}</td>
                )}
                {showColumns.device_status && (
                  <td>
                    {pack.device_pack_info?.status ? (
                      <Badge
                        bg={this.deviceStatusBadgeVariant(pack.device_pack_info.status)}
                        style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        title={pack.device_pack_info.SN ? `SN: ${pack.device_pack_info.SN}` : undefined}
                      >
                        {this.mapDeviceStatus(pack.device_pack_info.status)}
                      </Badge>
                    ) : '-'}
                  </td>
                )}
                {showColumns.etsy_shop_name && (
                  <td>
                    {shopName ? (
                      <div className="d-flex align-items-center gap-2">
                        {/* Icon tròn theo trạng thái đăng ký */}
                        <span
                          style={{
                            width: '12px',
                            height: '12px',
                            borderRadius: '50%',
                            backgroundColor: registration.color,
                            display: 'inline-block',
                            flexShrink: 0
                          }}
                          title={registration.title}
                        />
                        {pack.seller_registration_date ? (
                          <>
                            <a
                              href={`https://etsy.com/shop/${shopName}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-decoration-none"
                              style={{ color: '#007bff' }}
                              title={`Mở shop Etsy | ${registration.title}`}
                            >
                              {shopName}
                            </a>
                            <FaExternalLinkAlt
                              size={12}
                              style={{ cursor: 'pointer', color: '#6c757d' }}
                              onClick={() => window.open(`https://etsy.com/shop/${shopName}`, '_blank')}
                              title="Mở shop Etsy"
                            />
                          </>
                        ) : (
                          <span
                            style={pack.buyer_registration_date ? undefined : { color: '#dc3545' }}
                            title={registration.title}
                          >
                            {shopName}
                          </span>
                        )}
                        <FaCopy
                          size={12}
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(shopName)}
                          title="Copy Shop Name"
                        />
                      </div>
                    ) : '-'}
                  </td>
                )}
                {showColumns.etsy_shop_status && (
                  <td>
                    {registeredShop ? (
                      <Badge
                        bg={this.statusBadgeVariant(registeredShop.status)}
                        style={{ fontSize: '0.8em', padding: '4px 8px', cursor: 'pointer' }}
                        onClick={() => this.handleRegisteredShopClick(pack)}
                        title={`${registeredShop.MID || ''}${registeredShop.shop_id ? ` | Shop ID: ${registeredShop.shop_id}` : ''} - Click để xem Registered Shop`}
                      >
                        {this.mapStatus(registeredShop.status)}
                      </Badge>
                    ) : (
                      <span className="text-muted" title="Chưa có Registered Shop">-</span>
                    )}
                  </td>
                )}
                {showColumns.anydesk_id && (
                  <td>{this.renderCopyable(pack.device_pack_info?.anydesk_id, 'AnyDesk ID')}</td>
                )}
                {showColumns.anydesk_password && (
                  <td>{this.renderPasswordCell(pack)}</td>
                )}
                {showColumns.MID && (
                  <td>
                    {pack.MID ? (
                      <div className="d-flex align-items-center gap-2">
                        <Badge
                          bg="primary"
                          style={{ fontSize: '0.9em', padding: '6px 10px', cursor: 'pointer' }}
                          onClick={() => this.handleEtsyInfoPackClick(pack.MID)}
                          title="Click để xem chi tiết Info Pack"
                        >
                          {pack.MID}
                        </Badge>
                        <FaCopy
                          size={12}
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(pack.MID)}
                          title="Copy Info Pack MID"
                        />
                      </div>
                    ) : '-'}
                  </td>
                )}
                {showColumns.status && (
                  <td>
                    {pack.status ? (
                      <Badge bg={this.statusBadgeVariant(pack.status)} style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                        {this.mapStatus(pack.status)}
                      </Badge>
                    ) : '-'}
                  </td>
                )}
                <td>
                  {pack.device_pack_info?.PCSN ? (
                    <FaExternalLinkAlt
                      size={14}
                      style={{ cursor: 'pointer', color: '#6c757d' }}
                      title={`Xem PC Info - ${pack.device_pack_info.PCSN}`}
                      onClick={() => this.handlePcInfoClick(pack)}
                    />
                  ) : '-'}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }

  render() {
    return (
      <>
        <Container fluid>
          <Row className="mb-4">
            <Col>
              <h2 className="text-primary">
                TKT1 Etsy Info Device Pack - Danh sách tất cả
              </h2>
            </Col>
          </Row>
          {this.renderSearchFilter()}
          <Row>
            <Col>
              <h5 className="d-inline-block">
                <b>Tìm thấy <span className='text-danger'>{this.props.totalCount}</span> bản ghi:</b>
              </h5>
            </Col>
            <Col className="text-end text-nowrap" md="auto">
              <div className="d-inline-flex align-items-center flex-nowrap">
                <Button
                  variant="secondary"
                  size="sm"
                  className="me-2"
                  onClick={() => this.setState({ showConfigModal: true })}
                >
                  <i className="fas fa-cog"></i> Cấu hình hiển thị
                </Button>
                <div className="d-inline-block ms-3">
                  <span className="me-2">Số bản ghi/trang:</span>
                  <Form.Select
                    size="sm"
                    value={this.state.query.itemsPerPage}
                    onChange={this.handleChangeItemsPerPage}
                    style={{ width: '100px', display: 'inline-block' }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={200}>200</option>
                  </Form.Select>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="sticky-table">
                {this.renderPackTable()}
              </div>
            </Col>
          </Row>
        </Container>
        <Pagination
          totalItems={this.props.totalCount}
          itemsPerPage={this.state.query.itemsPerPage}
          itemOffset={(this.state.query.currentPage - 1) * this.state.query.itemsPerPage}
          updatePage={this.updatePage}
        />

        {/* Configuration Modal */}
        <Modal show={this.state.showConfigModal} onHide={() => this.setState({ showConfigModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Cấu hình hiển thị</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="mb-3">
                <h6>Hiển thị cột</h6>
                {Object.entries(this.state.showColumns || {}).map(([column, isVisible]) => (
                  <Form.Check
                    key={column}
                    type="switch"
                    id={`column-${column}`}
                    label={this.columnLabels[column] || column}
                    checked={isVisible}
                    onChange={() => this.handleColumnToggle(column)}
                    className="mb-2"
                  />
                ))}
              </div>
              <Button variant="outline-secondary" size="sm" onClick={this.resetColumnWidths}>
                Đặt lại độ rộng cột
              </Button>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showConfigModal: false })}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Iframe Modal */}
        <IframeModal
          show={this.state.showIframeModal}
          onHide={this.handleCloseIframeModal}
          url={this.state.iframeUrl}
          title={this.state.iframeTitle}
          showSidebar={false}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    etsyInfoPacks: state.tkt1EtsyInfoPackReducer?.etsyInfoPacks || [],
    totalCount: state.tkt1EtsyInfoPackReducer?.totalCount || 0
  };
};

export default connect(mapStateToProps, { getTKT1EtsyInfoPacks })(TKT1EtsyInfoDevicePack);
